import { Components, Theme } from '@mui/material'

import Fonts from '#/styles/Fonts'

export function OverridedInput(theme: Theme): Components {
  return {
    MuiFormLabel: {
      styleOverrides: {
        root: {
          color: theme.palette.grey[700],
        },
      },
    },
    MuiInputAdornment: {
      styleOverrides: {
        positionEnd: {
          fontSize: Fonts.fontSize.SS,
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        input: {
          '&::file-selector-button': {
            display: 'none',
          },
        },
        root: {
          '& > p': {
            margin: 0,
          },
          'minHeight': 39,
        },
      },
    },
    MuiInputLabel: {
      defaultProps: {
        shrink: true,
      },
      styleOverrides: {
        animated: ({ ownerState }) => ({
          ...(ownerState.variant !== 'outlined' && { fontSize: Fonts.fontSize.M }),
        }),
        root: ({ ownerState }) => ({
          color: theme.palette.grey[700],
          ...(ownerState.variant !== 'outlined' && { fontSize: Fonts.fontSize.M }),
        }),
      },
    },
    MuiTextField: {
      defaultProps: {
        variant: 'standard',
      },
    },
  }
}
